module.exports = __webpack_public_path__ + "components/guide-page/static/icon-hood-f7f57bfdcbd00f3ad700056056294b9c.svg";